import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  container: {
    position: 'relative',
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column'
  },
  content: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    gridGap: '24px',
    margin: '0 30px',
    position: 'relative'
  }
}));
